<template>
  <div class="flex w-full lg:pb-2 flex-col lg:flex-row">
    <bar-chart :is-loading="isLoading"
               :data="chartData"
               :is-stacked="true"
               :total="totalRequests"
               title="Most used Answers"
               :categories="categories"
               id="intents-usage-chart"
               :tooltip-builder="intentsUsageTooltipUtils"
               :outcome-types="outcomeTypes"
               class="w-full lg:w-8/12 pt-8 pb-4 lg:pb-10 px-6 lg:px-16 border-0 border-b border-solid border-gray-a10 lg:border-none"
    />
    <number-chart :is-loading="isLoading"
                  :value="totalPublishedIntents"
                  :suffix="` / ${totalIntents}`"
                  :title="'Total Answers'"
                  id="intents-usage-number"
                  :hint="hint"
                  class="flex-grow justify-around pt-10 lg:py-10 border-0 lg:border-l border-solid border-gray-a10"
    />
  </div>
</template>

<script>
import BarChart from '@/components/analytics/charts/BarChart'
import NumberChart from '@/components/analytics/charts/NumberChart'
import intentsUsageTooltipUtils from '@/utils/intents-usage-tooltip.utils'
import { CHART_TEXT } from '@/utils/text.constants'
import chartLabels from '@/utils/chart-labels'
import botModule from '@/store/modules/bot.module'

export default {
  name: 'IntentsUsagesCharts',

  components: {
    BarChart,
    NumberChart
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    intents: {
      type: Array,
      default: () => []
    },
    totalRequests: {
      type: Number,
      default: 0
    },
    totalIntents: {
      type: Number,
      default: 0
    },
    totalPublishedIntents: {
      type: Number,
      default: 0
    },
    getSeriesData: {
      type: Function,
      default: () => {}
    }
  },

  data() {
    return {
      intentsUsageTooltipUtils,
      hint: CHART_TEXT.PUBLISHED_ANSWERS_HINT
    }
  },

  computed: {
    isEmailBot() {
      return botModule.isEmailBot()
    },

    outcomeTypes() {
      return this.isEmailBot ? ['fullyAutomated', 'requestedOperator'] : ['fullyAutomated', 'partlyAutomated', 'wrongAnswer']
    },

    chartData() {
      if (this.isEmailBot) {
        return [
          {
            name: 'Requested operator',
            colorType: chartLabels.requestedOperator.color,
            data: this.getSeriesData('requestedOperator')
          },
          {
            name: 'Fully automated',
            colorType: chartLabels.fullyAutomated.color,
            data: this.getSeriesData('fullyAutomated')
          }
        ]
      }

      return [
        {
          name: 'Wrong answer',
          colorType: chartLabels.wrongAnswer.color,
          data: this.getSeriesData('wrongAnswer')
        },
        {
          name: 'Partly automated',
          colorType: chartLabels.partiallyAutomated.color,
          data: this.getSeriesData('partiallyAutomated')
        },
        {
          name: 'Fully automated',
          colorType: chartLabels.fullyAutomated.color,
          data: this.getSeriesData('fullyAutomated')
        }
      ]
    },

    categories() {
      return this.intents?.map(({ answer_name }) => answer_name)
    }
  }
}
</script>

